import { Fragment } from 'react';

import { Item, ItemContent, ItemTitle } from '@nesso/ui/primitives/item';
import { Separator } from '@nesso/ui/primitives/separator';

import type { ClientBalance } from '@/entities/session-charge';
import { formatCurrencyFromCents } from '@/shared/lib/format-utils';

type Props = {
    balance: ClientBalance | undefined;
};

export function ClientBillingSheetSummary({ balance }: Props) {
    if (!balance) {
        return (
            <Item variant="muted" size="sm" alignment="center">
                <ItemContent>
                    <ItemTitle>Couldn't load billing summary</ItemTitle>
                </ItemContent>
            </Item>
        );
    }

    const figures = [
        { label: 'Balance', cents: balance.balanceCents },
        { label: 'Credits', cents: balance.creditsCents },
        { label: 'Refunds', cents: balance.refundsCents },
        { label: 'Write-offs', cents: balance.writeOffsCents },
    ];

    return (
        <div className="flex items-stretch justify-between gap-2">
            {figures.map(({ label, cents }, index) => (
                <Fragment key={label}>
                    {index > 0 && (
                        <Separator
                            orientation="vertical"
                            className="self-center data-[orientation=vertical]:h-13"
                        />
                    )}
                    <div className="flex flex-col gap-2">
                        <span className="text-sm font-medium text-card-foreground">{label}</span>
                        <span
                            className={
                                label === 'Balance' && cents > 0
                                    ? 'text-2xl font-bold text-destructive'
                                    : 'text-2xl text-muted-foreground'
                            }
                        >
                            {formatCurrencyFromCents(cents)}
                        </span>
                    </div>
                </Fragment>
            ))}
        </div>
    );
}
